import type { CalendarConfigProvider } from '.'

export function getPlatformCalendarConfigProvider(): CalendarConfigProvider {
  return {}
}
